module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/movie-611845509d79da2bec174f07b9bf4c0a.mp4";